import EmployeeProfile, {STAFF_TAB_SECTIONS} from './EmployeeProfile';
import {useOutletContext} from 'react-router-dom';
import React, {useState} from 'react';
import PropTypes from 'prop-types';
import StaffCategoriesSection from './StaffCategoriesSection';
import useUser from '../../../utility/hooks/useUser';

// Maria, 18 October 2026: one tab of the staff profile (Profile, Contacts, Banking or Cars)
const AdminEmployeeInformation = ({tab = 'profile'}) => {
    const {data, isLoading, framed, staffPermissions, self} = useOutletContext();
    const {user} = useUser();
    // Maria, 19 October 2026: Cancel, or opening another tab, leaves edit mode and drops unsaved changes.
    const [cancelled, setCancelled] = useState(0);

    return <>
        <EmployeeProfile
            key={`${tab}-${cancelled}`}
            data={data}
            isLoading={isLoading}
            staffPermissions={staffPermissions}
            sections={STAFF_TAB_SECTIONS[tab]}
            framed={framed}
            onCancel={() => setCancelled(n => n + 1)}
        />
        {/* AD-2790: the staff categories under the Profile tab's boxes */}
        {tab === 'profile' && !isLoading && data?.id && (
            <StaffCategoriesSection
                self={Boolean(self)}
                employeeId={data.id}
                permissions={staffPermissions || user.permissions || []}
            />
        )}
    </>;
};

AdminEmployeeInformation.propTypes = {
    tab: PropTypes.oneOf(['profile', 'contacts', 'banking', 'cars'])
};

export default AdminEmployeeInformation;
